import React from 'react';
import './InactiveBotAlert.scss';
import { Alert } from '@mm/components';
import { useShowInactiveBannerFlag } from '../../common/hooks/use-show-inactive-bot-banner-flag';

export const InactiveBotAlert = () => {
  const { botAlertVisible, setBotAlertVisible, onClickActivate } =
    useShowInactiveBannerFlag();

  const onCloseBotAlert = () => {
    setBotAlertVisible(false);
  };

  return botAlertVisible ? (
    <Alert
      className="inactive-bot-alert"
      borderRadius={0}
      closeIconProps={{
        onClick: onCloseBotAlert,
      }}
      type="warning"
    >
      <div>
        This bot is currently inactive.{' '}
        <span
          className="inactive-bot-alert__action"
          onClick={() => onClickActivate()}
        >
          Click here to activate it
        </span>
      </div>
    </Alert>
  ) : null;
};
